import {
  DataService,
  ModalService,
  NotificationService,
  addNavMenuItem,
  registerBulkAction,
} from "@bb-vendure/admin-ui/core";
import { forkJoin, take } from "rxjs";
import { DeleteBannerDocument } from "./generated/graphql";

export default [
  addNavMenuItem(
    {
      id: "banner",
      label: "nav.banners",
      routerLink: ["/extensions/banners"],
      icon: "flag",
    },
    "marketing"
  ),

  // registerBulkAction({
  //   location: "banner-list",
  //   label: "Set Banners Status",
  //   icon: "stop-circle",
  //   iconClass: "is-success",
  //   onClick: ({ injector, selection, hostComponent, clearSelection }) => {
  //     const modal = injector.get(ModalService);
  //     modal
  //       .dialog({
  //         title: "Set Banners Status",
  //         body: `Set the status of ${selection.length} banners to enabled or disabled`,
  //         buttons: [
  //           { label: "Cancel", type: "secondary" },
  //           { label: "Enable", type: "primary", returnValue: true },
  //           { label: "Disable", type: "danger", returnValue: false },
  //         ],
  //       })
  //       .pipe(take(1))
  //       .subscribe((result) => {
  //         if (result !== undefined) {
  //           // Perform the status change operation
  //           alert(
  //             `Setting ${selection.length} banners to ${
  //               result ? "enabled" : "disabled"
  //             }`
  //           );
  //           clearSelection();
  //         }
  //       });
  //   },
  // }),

  registerBulkAction({
    location: "banner-list",
    label: "Delete Banners",
    icon: "trash",
    iconClass: "is-danger",
    onClick: ({ injector, selection, hostComponent, clearSelection }) => {
      const modal = injector.get(ModalService);
      const dataService = injector.get(DataService);
      const noti = injector.get(NotificationService);
      modal
        .dialog({
          title: "Delete Banners",
          body: `Are you sure you want to delete ${selection.length} banners?`,
          buttons: [
            { label: "Cancel", type: "secondary", returnValue: false },
            { label: "Delete", type: "danger", returnValue: true },
          ],
        })
        .pipe(take(1))
        .subscribe((result) => {
          if (result) {
            const deleteObservables = selection.map((item) =>
              dataService.mutate(DeleteBannerDocument, { id: item.id })
            );

            forkJoin(deleteObservables).subscribe(res => {
              noti.success(`Deleted ${res.length} banners`);
              hostComponent.refresh();
              clearSelection();
            });
          }
        });
    },
  }),
];
